"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureHashType = void 0;
const scryptTypes_1 = require("scryptlib/dist/scryptTypes");
Object.defineProperty(exports, "SignatureHashType", { enumerable: true, get: function () { return scryptTypes_1.SignatureHashType; } });
//# sourceMappingURL=types.js.map